import { ctrlID } from '../../constants/ctr-id';

export const settingConfigs = {
  language: 'en',
  theme: 'light',
  LONG_DATE: 'YYYY-MM-DD HH:mm:ss',
  SHORT_DATE: 'YYYY-MM-DD',
  PRICE: {
    decimal: 3,
    thousandSeparator: ',',
    decimalSeparator: '.',
    minusSign: '-'
  },
  AMOUNT: {
    decimal: 3,
    thousandSeparator: ',',
    decimalSeparator: '.'
  },
  QUANTITY: {
    decimal: 0,
    thousandSeparator: ',',
    decimalSeparator: '.'
  },
  AVG_PRICE: {
    decimal: 5,
    thousandSeparator: ',',
    decimalSeparator: '.'
  },
  CASH: {
    decimal: 2,
    thousandSeparator: ',',
    decimalSeparator: '.'
  },
  STOP_PRICE: {
    decimal: 6,
    thousandSeparator: ',',
    decimalSeparator: '.'
  },
  FUNDS_QUANTITY: {
    decimal: 4,
    thousandSeparator: ',',
    decimalSeparator: '.'
  }
}

export const appEnvironment = {
  company: 'eif',
  market: 'hk',
  version: 'itrade7.5-ttl-v7.0.3',
  company_title: 'company_title',
  gtm: 'hk_gtm',
  customer_order_status_prefix: '',
  language: ['zh_TW', 'zh_CN', 'en_US'],
  custom_ctr_configs: {
    accountCtr: {
      enabledCashInfo: false,
      enabledFund: false,
      enabledCurrencyBalance: false,
      enabledAssetAllocation: true,
      enabledAccountBalance: true,
      enableCashTransfer: false,
      enableFloatPL: true,
      enabledAccountProfile: true
    },
    marketCtr: {
      enableQuote: true
    },
    accountCtrl: {
      id: ctrlID.accountCtrl,
      child: []
    },
    tradeCtrl: {
      id: ctrlID.tradeCtrl,
      child: [ctrlID.accountCtrl]
    },
    marketCtrl: {
      id: ctrlID.marketCtrl,
      child: [ctrlID.addWlCtrl, ctrlID.bidAskCtrl]
    }
  }
}

const INTERVAL = {
  MINUTE: 'OneMinute',
  MINUTES_5: 'FiveMinute',
  MINUTES_15: 'FifteenMinute',
  HOUR: 'OneHour',
  DAY: 'Daily'
}

export const chartingConfigs = {
  ranges: [
    { id: 'daily', label: 'chart_range_daily', resolution: INTERVAL.DAY },
    { id: '60m', label: 'chart_range_60_min', resolution: INTERVAL.HOUR },
    { id: '15min', label: 'chart_range_15_min', resolution: INTERVAL.MINUTES_15 },
    { id: '5min', label: 'chart_range_5_min', resolution: INTERVAL.MINUTES_5 },
    { id: '1min', label: 'chart_range_1_min', resolution: INTERVAL.MINUTE }
  ],
  areaSeries: {
    top: 'rgba(33, 150, 243, 0.65)',
    middle: 'rgba(33, 150, 243, 0.56)',
    bottom: 'rgba(33, 150, 243, 0.04)',
    lineColor: 'rgba(33, 150, 243, 0.65)',
    strokeWidth: 2
  },
  volumeSeries: {
    color: '#26a69a',
    priceFormat: {
      type: 'volume',
    },
    priceScaleId: '',
    scaleMargins: {
      top: 0.8,
      bottom: 0,
    }
  },
  dark: {
    chart: {
      layout: {
        backgroundColor: '#232c37',
        lineColor: '#232c37',
        textColor: '#D9D9D9',
      },
      watermark: {
        color: 'rgba(0, 0, 0, 0)',
      },
      crosshair: {
        color: '#758696',
      },
      grid: {
        vertLines: {
          color: '#232c37',
        },
        horzLines: {
          color: '#363C4E',
        },
      },
    },
    series: {
      topColor: 'rgba(25, 150, 227, 0.56)',
      bottomColor: 'rgba(25, 150, 227, 0.04)',
      lineColor: 'rgba(25, 150, 227, 1)',
    },
    color: {
      riseRed: '#cc3d3d',
      fallGreen: '#47b364',
      riseGreen: '#47b364',
      fallRed: '#cc3d3d'
    }
  },
  light: {
    chart: {
      layout: {
        backgroundColor: '#FFFFFF',
        lineColor: '#232c37',
        textColor: '#191919',
      },
      watermark: {
        color: 'rgba(0, 0, 0, 0)',
      },
      grid: {
        vertLines: {
          visible: false,
        },
        horzLines: {
          color: '#f0f3fa',
        },
      },
    },
    series: {
      topColor: 'rgba(25, 150, 227, 0.56)',
      bottomColor: 'rgba(25, 150, 227, 0.04)',
      lineColor: 'rgba(25, 150, 227, 1)',
    },
    color: {
      riseRed: '#cc3d3d',
      fallGreen: '#47b364',
      riseGreen: '#47b364',
      fallRed: '#cc3d3d'
    }
  },
  dateFormat: {
    yearFormat: "%Y",
    quarterFormat: "%m/%Y", //Display in Timeline
    monthFormat: "%b", //Display in Timeline
    weekFormat: "%m/%d", //Day Chart
    dayFormat: "%m/%d", // Minutes chart
    hourFormat: "%_H:%M", //Use 24hours as default - // Minutes chart
    minuteFormat: "%H:%M", // Minutes chart
    secondFormat: "%H:%M:%S",
    milliSecondFormat: "%L",
  }
}

export const appAuthType = {
  isClientIDLogin: true
}

export const ipoCancel = {
  applyMarginCancel:false
}

export const OTPConfig = {
  number:6
}